const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/PDFViewer/PDFPageInfo.tsx';
import { Chip } from '@mui/material';
import { css, cx } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import React, { useMemo } from 'react';

interface Props {
    className?: string;
    pageCount: number;
    pageNumber: number;
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            chipCSS: css`
                background-color: rgba(0, 0, 0, 0.55);
                color: ${theme.palette.common.white};

                & .MuiChip-label {
                    padding-right: ${theme.spacing(1)};
                    padding-left: ${theme.spacing(1)};
                }
            `,
        }),
        [theme]
    );
}

export const PDFPageInfo = (props: Props) => {
    const classes = useCSSClasses();

    if (props.pageCount <= 1) return null;

    return (
        <Chip
            className={cx(classes.chipCSS, props.className)}
            label={`${props.pageNumber} / ${props.pageCount}`}
            size="small"
        />
    );
};
